module.exports = __webpack_public_path__ + "img/illu-hole.0bdbead2.svg";